import { useNotification } from '@/containers'
import { type StaticImageData } from 'next/image'
import { type FC } from 'react'
import { CompareAddIcon } from '../Icon/CompareAddIcon'
import ImageOptimize from '../ImageOptimize'

interface Props {
  imgSrc: StaticImageData | string | undefined
  imgAlt: string
  id: string
  finalPrice: string
  salePrice: string
  name: string
  className?: string
  canCompare?: boolean
  handleAddToCompare?: () => void
}
export const SearchProductItemCard: FC<Props> = ({
  imgSrc,
  imgAlt,
  name,
  finalPrice,
  salePrice,
  canCompare,
  className = '',
  handleAddToCompare,
}) => {
  const { systemConfig } = useNotification()

  return (
    <div className='flex flex-wrap border-b py-2 px-3 items-center w-full'>
      <ImageOptimize
        alt={imgAlt}
        src={
          imgSrc ||
          systemConfig?.imageWarehousePlaceholder ||
          process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
          ''
        }
        width={60}
        priority
        height={60}
        className='h-full max-h-[60px] w-[60px] object-cover'
      />
      <div
        className={`pl-5 leading-snug text-left flex-[0_0_calc(100%-60px)] ${className}`}
      >
        <p className={`line-clamp-2 text-sm font-semibold text-dark-800`}>
          {name}
        </p>
        <p className='text-dark-500 text-xs'>{salePrice}</p>
        <p className='memberPrice text-base text-primary-base font-bold'>
          {finalPrice}
        </p>
      </div>
      {canCompare && (
        <button
          onClick={handleAddToCompare}
          className='r-[10px] relative flex w-[125px] items-center flex-[135px] justify-end'
        >
          <CompareAddIcon className='mr-[5px]'></CompareAddIcon>
          <span className='text-blue'>So sánh</span>
        </button>
      )}
    </div>
  )
}
